var render = function render(){var _vm=this,_c=_vm._self._c;return _c('passport-view',{attrs:{"passport":_vm.passport_view}})
}
var staticRenderFns = []

export { render, staticRenderFns }